// extracted by mini-css-extract-plugin
module.exports = {"playButtonOuter":"PlayButton_playButtonOuter__1Amce","img":"PlayButton_img__2aYtc"};